
export const getSalesForecastPosting = state => {
  return state.salesForecastPosting
}

export const getSalesForecastErrors = state => {
  return state.salesForecastErrors
}

export const getSalesForecastTotals = state => {
  return state.salesForecastTotals
}

export const getSalesForecastPosted = state => {
  return state.salesForecastPosted
}


export const getMainListQuickFilter = state => {
  return state.mainListQuickFilters
}

export const getQuickFiltersDatesFrom = state => {
  return state.quickFiltersDatesFrom
}

export const getQuickFiltersDatesTo = state => {
  return state.quickFiltersDatesTo
}